import { BankAccount } from 'types/bankAccountTypes';

export const createBankAccount = (id: string): BankAccount => ({
  id,
  unp: '',
  name: '',
});

export const createBankAccountMock = (): BankAccount => ({
  id: 'BY80ALFA30121122220090270000',
  unp: '101541947',
  name: 'ЗАО "АЛЬФА-БАНК"',
});
